import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    black: '#010302',
    camel: '#AA8B5D',
    camelLight: '#BF9D6D',
    shadowGrey: '#221E1F',
    gunmetal: '#3E3F41',
    charcoal: '#58585A',
    paleOak: '#D4BFA0',
    bone: '#EDE0CD',
    taupe: '#3E3F41',
    carbonBlack: '#010302',
    dimGrey: '#58585A',
    drySage: '#EDE0CD',
    graphite: '#221E1F',
    stormyTeal: '#3E3F41',
    alabasterGrey: '#D4BFA0',
    yaleBlue: '#010302',
    crimson: '#3E3F41',
    darkCrimson: '#221E1F',
  },
  fonts: {
    heading: `'Radley', sans-serif`,
    body: `'Radley', sans-serif`,
    accent: `'Radley', sans-serif`,
    team: `'Montserrat', sans-serif`,
  },
  styles: {
    global: {
      body: {
        bg: 'drySage',
        color: 'graphite',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 600,
        borderRadius: '4px',
      },
      variants: {
        primary: {
          bg: 'yaleBlue',
          color: 'white',
          _hover: {
            bg: 'shadowGrey',
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
          },
          transition: 'all 0.3s ease',
        },
        secondary: {
          bg: 'crimson',
          color: 'white',
          _hover: {
            bg: 'shadowGrey',
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
          },
          transition: 'all 0.3s ease',
        },
        outline: {
          borderColor: 'yaleBlue',
          color: 'yaleBlue',
          borderWidth: '2px',
          _hover: {
            bg: 'yaleBlue',
            color: 'white',
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        fontFamily: 'heading',
        fontWeight: 700,
      },
    },
  },
  space: {
    4: '1rem',
    8: '2rem',
    12: '3rem',
    16: '4rem',
    20: '5rem',
    24: '6rem',
    32: '8rem',
    40: '10rem',
    48: '12rem',
    56: '14rem',
    64: '16rem',
  },
});

export { theme };
